module.exports = __webpack_public_path__ + "img/closed.34e49321.svg";